import MultiSelectInput from '@repo/ui/multiselect-input'
import { useQuery } from '@tanstack/react-query'

import { getCountries } from '../../../api/countries/get-countries'
import {
  AccomodationEnum,
  accomodationEnumMapping
} from '../../../lib/types/enums/accomodation-type/accomodation-type'
import { JourneyPlaceFilters } from '../../../lib/types/models/journey-place/journey-place'

interface Props {
  filter?: JourneyPlaceFilters
  onFilterChange: (filter: JourneyPlaceFilters) => void
}

export function JourneyPlacesFilter({ filter, onFilterChange }: Props) {
  function setFilter<K extends keyof JourneyPlaceFilters>(key: K, value: JourneyPlaceFilters[K]) {
    onFilterChange({ ...filter, [key]: value })
  }

  const { data: countries } = useQuery({
    queryKey: ['countries'],
    queryFn: () => getCountries()
  })

  return (
    <div className={'flex flex-col gap-3'}>
      <div />

      <MultiSelectInput
        label={'Pays'}
        variant={'primary'}
        searchable
        options={countries?.data?.map((country) => ({
          label: country.name,
          value: country.id
        }))}
        onChange={(countryIds) => setFilter('countryIds', countryIds)}
        selectedOptions={filter?.countryIds?.map((countryId) => ({
          label: countries?.data?.find((a) => a.id === countryId)?.name || '',
          value: countryId
        }))}
      />

      <MultiSelectInput
        label={"Type d'hébergement"}
        variant={'primary'}
        searchable
        options={Object.values(AccomodationEnum).map((option) => ({
          label: accomodationEnumMapping[option],
          value: option
        }))}
        selectedOptions={filter?.accomodations?.map((accommodation) => ({
          label: accomodationEnumMapping[accommodation],
          value: accommodation
        }))}
        onChange={(accomodations) => setFilter('accomodations', accomodations)}
      />
    </div>
  )
}
